
import { useState } from 'react';

export default function Header() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white backdrop-blur-sm shadow-sm z-40">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/d4d6d97e1263ef61b1eee88f513b68c5/b1e146a3ca6731056b6baa3246ca1b7c.png"
              alt="DataPrec Logo"
              className="h-10 w-auto"
            />
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-blue-700 transition-colors cursor-pointer"
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-gray-700 hover:text-blue-700 transition-colors cursor-pointer"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-gray-700 hover:text-blue-700 transition-colors cursor-pointer"
            >
              Soluções
            </button>
            <button
              onClick={() => scrollToSection('diferenciais')}
              className="text-gray-700 hover:text-blue-700 transition-colors cursor-pointer"
            >
              Diferenciais
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-6 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-800 transition-all cursor-pointer whitespace-nowrap"
            >
              Contato
            </button>
          </nav>

          {/* Mobile menu button */}
          <button className="md:hidden p-2">
            <i className="ri-menu-line text-2xl text-gray-700"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
